import { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { Spin } from 'antd';

const TransactionHubView = lazy(() => import('./views/TransactionHubView'));
const PendingTransactionsView = lazy(() => import('./views/PendingTransactionsView'));
const TransactionReversalView = lazy(() => import('./views/TransactionReversalView'));

const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center">
    <Spin size="large" tip="Loading..." />
  </div>
);

export const transactionHubRoutes: RouteObject[] = [
  {
    path: 'transactions',
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <TransactionHubView />
          </Suspense>
        ),
      },
      {
        path: 'hub',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <TransactionHubView />
          </Suspense>
        ),
      },
      {
        path: 'pending',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <PendingTransactionsView />
          </Suspense>
        ),
      },
      {
        path: 'history',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <PendingTransactionsView />
          </Suspense>
        ),
      },
      {
        path: 'error-correction',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <TransactionReversalView />
          </Suspense>
        ),
      },
    ],
  },
];

export default transactionHubRoutes;
